export function defaultBreakPoint(){
    return 768;
}

export function isScreeSmall(breakPointToUse = 0) {
    breakPointToUse = breakPointToUse == 0 ? defaultBreakPoint() : breakPointToUse;
    return window.innerWidth > breakPointToUse ? false : true;
}
